import React, { useState, useEffect } from 'react';
import {
  Box,
  Container,
  Heading,
  Text,
  Button,
  Image,
  SimpleGrid,
  Icon,
  VStack,
  HStack,
} from '@chakra-ui/react';
import { FaUserPlus, FaTable, FaUsers, FaGamepad } from 'react-icons/fa';
import { ExternalLinkIcon } from '@chakra-ui/icons';
import { Link } from 'react-router-dom';
import LaSedeImage2 from '../images/la-sede-3.jpg';

const LaSede = () => {
  const imagesCIL = [
    require('../images/la-sede.jpg'),
    require('../images/la-sede-2.jpg'),
    require('../images/la-sede-4.jpg'),
    require('../images/la-sede-5.jpg'),
    require('../images/swapparty.jpg'),
  ];

  const [slideIndex, setSlideIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setSlideIndex((prev) => (prev + 1) % imagesCIL.length);
    }, 4000);
    return () => clearInterval(interval);
  }, []);

  return (
    <Box bg="#36393f" minH="100vh" color="white" pb={8}>
      {/* HERO SECTION (stesso stile di Network, Bazar e AboutUs: full width, overlay, container.xl) */}
      <Box
        position="relative"
        minHeight="320px"
        display="flex"
        alignItems="center"
        overflow="hidden"
      >
        <Box
          position="absolute"
          inset={0}
          backgroundImage={`url(${LaSedeImage2})`}
          backgroundPosition="center"
          backgroundSize="cover"
        />
        <Box
          position="absolute"
          inset={0}
          bgGradient="linear(to-b, rgba(15, 23, 42, 0.75) 0%, rgba(15, 23, 42, 0.5) 40%, rgba(15, 23, 42, 0.7) 100%)"
        />
        <Container
          maxW="container.xl"
          position="relative"
          zIndex={1}
          py={{ base: 10, md: 15 }}
          px={5}
          display="flex"
          alignItems="center"
          justifyContent="center"
        >
          <VStack textAlign="center" color="white" spacing={4} maxW="800px">
            <Heading
              as="h1"
              fontSize={{ base: '2xl', md: '3xl' }}
              fontWeight="800"
              letterSpacing="-0.03em"
              textShadow="0 1px 3px rgba(0,0,0,0.5), 0 2px 8px rgba(0,0,0,0.3)"
            >
              La Nostra Sede
            </Heading>
            <Text
              fontSize={{ base: 'md', md: 'lg' }}
              opacity={0.95}
              textShadow="0 1px 2px rgba(0,0,0,0.5)"
              lineHeight="1.6"
            >
              Il cuore pulsante di CIL, dove la creatività prende vita e la
              comunità si incontra!
            </Text>
            <Button
              as={Link}
              to="/tesseramento"
              bg="#facc15"
              color="#0f172a"
              size="md"
              rightIcon={<FaUserPlus />}
              fontWeight="600"
              borderRadius="12px"
              boxShadow="0 2px 8px rgba(0,0,0,0.25)"
              _hover={{ bg: '#fde047', color: '#0f172a' }}
              transition="all 0.2s ease"
            >
              Diventa Socio
            </Button>
          </VStack>
        </Container>
      </Box>

      {/* SEZIONE PRINCIPALE - Un Luogo Unico (compatta) */}
      <Box
        bg="#2f3136"
        py={{ base: 8, md: 12 }}
        px={{ base: 4, md: 6 }}
        mx={{ base: 4, md: 8 }}
        borderRadius="12px"
        boxShadow="lg"
        mt={{ base: -6, md: -12 }}
        position="relative"
        zIndex={2}
        border="1px solid"
        borderColor="gray.600"
      >
        <Container maxW="container.lg">
          <SimpleGrid
            columns={{ base: 1, lg: 2 }}
            spacing={{ base: 6, lg: 8 }}
            alignItems="center"
          >
            <VStack spacing={4} align="stretch">
              <VStack spacing={2} align="stretch">
                <Heading
                  as="h2"
                  size="xl"
                  color="white"
                  fontWeight="extrabold"
                  letterSpacing="tight"
                >
                  Un Luogo Unico
                </Heading>
                <Text
                  fontSize="md"
                  color="gray.300"
                  lineHeight="1.6"
                  fontWeight="medium"
                >
                  Benvenuti nella casa di CIL – Creatività in Libertà, un luogo
                  pensato per chi ama sperimentare, giocare e condividere
                  esperienze creative! La nostra sede è più di uno spazio
                  fisico: è un punto d&apos;incontro per appassionati di giochi
                  di società, Magic: The Gathering, attività artistiche e
                  iniziative educative.
                </Text>
                <Text
                  fontSize="md"
                  color="gray.300"
                  lineHeight="1.6"
                  fontWeight="medium"
                >
                  Lo spazio è attrezzato con ampi tavoli, librerie piene di
                  giochi e un&apos;area relax per chi vuole rilassarsi e
                  socializzare.
                </Text>
                <Box
                  mt={3}
                  p={4}
                  borderRadius="12px"
                  bg="rgba(255, 204, 0, 0.08)"
                  borderLeft="4px solid"
                  borderColor="#ffcc00"
                  borderRight="1px solid"
                  borderTop="1px solid"
                  borderBottom="1px solid"
                  borderRightColor="gray.600"
                  borderTopColor="gray.600"
                  borderBottomColor="gray.600"
                >
                  <Text
                    fontSize="sm"
                    color="gray.200"
                    lineHeight="1.6"
                    fontWeight="medium"
                  >
                    La sede viene mantenuta grazie al contributo dei soci e al
                    loro supporto attivo. Questo modello partecipato ci permette
                    di coltivare uno spirito di collaborazione e autosufficienza
                    di cui andiamo molto orgogliosi.
                  </Text>
                </Box>
              </VStack>
            </VStack>

            <Box
              position="relative"
              width="100%"
              height={{ base: '220px', md: '320px' }}
              borderRadius="12px"
              overflow="hidden"
              boxShadow="xl"
              border="3px solid"
              borderColor="white"
              transform="rotate(1deg)"
              _hover={{ transform: 'rotate(0deg) scale(1.02)' }}
              transition="all 0.4s cubic-bezier(0.4, 0, 0.2, 1)"
            >
              {imagesCIL.map((img, idx) => (
                <Image
                  key={`slide-image-${img.split('/').pop().split('.')[0]}`}
                  src={img}
                  alt={`Slide ${idx + 1} - La sede di CIL`}
                  objectFit="cover"
                  position="absolute"
                  top={0}
                  left={0}
                  width="100%"
                  height="100%"
                  opacity={slideIndex === idx ? 1 : 0}
                  transition="opacity 1.5s ease-in-out"
                  zIndex={slideIndex === idx ? 1 : 0}
                />
              ))}

              {/* Indicatori di slide */}
              <HStack
                position="absolute"
                bottom={4}
                left="50%"
                transform="translateX(-50%)"
                spacing={2}
                zIndex={2}
              >
                {imagesCIL.map((img, idx) => (
                  <Box
                    key={`slide-indicator-${img.split('/').pop().split('.')[0]}`}
                    w={3}
                    h={3}
                    borderRadius="full"
                    bg={slideIndex === idx ? 'white' : 'whiteAlpha.400'}
                    cursor="pointer"
                    onClick={() => setSlideIndex(idx)}
                    transition="all 0.3s"
                    _hover={{ bg: 'whiteAlpha.600' }}
                  />
                ))}
              </HStack>
            </Box>
          </SimpleGrid>
        </Container>
      </Box>

      {/* SEZIONE NUMERI - compatta */}
      <Box
        bg="#2f3136"
        py={{ base: 8, md: 10 }}
        px={{ base: 4, md: 6 }}
        mx={{ base: 4, md: 8 }}
        borderRadius="12px"
        boxShadow="lg"
        mt={6}
        position="relative"
        overflow="hidden"
        border="1px solid"
        borderColor="gray.600"
        _before={{
          content: '""',
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: `
            radial-gradient(circle at 20% 80%, rgba(120, 119, 198, 0.3) 0%, transparent 50%),
            radial-gradient(circle at 80% 20%, rgba(255, 119, 198, 0.3) 0%, transparent 50%),
            radial-gradient(circle at 40% 40%, rgba(120, 219, 255, 0.2) 0%, transparent 50%)
          `,
          zIndex: 1,
        }}
      >
        <Container maxW="container.lg" position="relative" zIndex={2}>
          <VStack spacing={6}>
            <VStack spacing={2} textAlign="center">
              <Heading as="h2" size="xl" color="white" fontWeight="extrabold">
                I Numeri della Nostra Sede
              </Heading>
              <Text
                fontSize="sm"
                color="gray.300"
                maxW="500px"
                lineHeight="1.5"
              >
                Scopri le dimensioni e le caratteristiche del nostro spazio
                creativo
              </Text>
            </VStack>

            <SimpleGrid
              columns={{ base: 1, md: 3 }}
              spacing={{ base: 4, md: 6 }}
              w="full"
            >
              <Box
                textAlign="center"
                bg="#36393f"
                borderRadius="12px"
                p={5}
                border="1px solid"
                borderColor="gray.600"
                _hover={{
                  transform: 'translateY(-4px)',
                  boxShadow: '0 12px 24px rgba(0,0,0,0.25)',
                  borderColor: '#ffcc00',
                }}
                transition="all 0.25s ease"
              >
                <Icon as={FaTable} w={10} h={10} color="#ffcc00" mb={3} />
                <Heading size="md" color="white" mb={2} fontWeight="bold">
                  Superficie Totale
                </Heading>
                <Text fontSize="2xl" fontWeight="extrabold" color="#ffcc00">
                  100 mq
                </Text>
                <Text fontSize="xs" color="gray.300" mt={1}>
                  Spazio ampio e confortevole
                </Text>
              </Box>

              <Box
                textAlign="center"
                bg="#36393f"
                borderRadius="12px"
                p={5}
                border="1px solid"
                borderColor="gray.600"
                _hover={{
                  transform: 'translateY(-4px)',
                  boxShadow: '0 12px 24px rgba(0,0,0,0.25)',
                  borderColor: '#ffcc00',
                }}
                transition="all 0.25s ease"
              >
                <Icon as={FaUsers} w={10} h={10} color="#36a9e1" mb={3} />
                <Heading size="md" color="white" mb={2} fontWeight="bold">
                  Capienza Massima
                </Heading>
                <Text fontSize="2xl" fontWeight="extrabold" color="#36a9e1">
                  30 persone
                </Text>
                <Text fontSize="xs" color="gray.300" mt={1}>
                  Eventi e workshop inclusi
                </Text>
              </Box>

              <Box
                textAlign="center"
                bg="#36393f"
                borderRadius="12px"
                p={5}
                border="1px solid"
                borderColor="gray.600"
                _hover={{
                  transform: 'translateY(-4px)',
                  boxShadow: '0 12px 24px rgba(0,0,0,0.25)',
                  borderColor: '#ffcc00',
                }}
                transition="all 0.25s ease"
              >
                <Icon as={FaGamepad} w={10} h={10} color="#e95995" mb={3} />
                <Heading size="md" color="white" mb={2} fontWeight="bold">
                  Giochi da Tavolo
                </Heading>
                <Text fontSize="2xl" fontWeight="extrabold" color="#e95995">
                  25+
                </Text>
                <Text fontSize="xs" color="gray.300" mt={1}>
                  Collezione in continua crescita
                </Text>
              </Box>
            </SimpleGrid>
          </VStack>
        </Container>
      </Box>

      {/* CTA FINALE - compatta */}
      <Box
        bg="#2f3136"
        py={{ base: 8, md: 10 }}
        px={{ base: 4, md: 6 }}
        mx={{ base: 4, md: 8 }}
        borderRadius="12px"
        boxShadow="lg"
        mt={6}
        mb={6}
        position="relative"
        overflow="hidden"
        border="1px solid"
        borderColor="gray.600"
        _before={{
          content: '""',
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: `
            radial-gradient(circle at 30% 70%, rgba(255, 204, 0, 0.1) 0%, transparent 50%),
            radial-gradient(circle at 70% 30%, rgba(62, 178, 151, 0.1) 0%, transparent 50%)
          `,
          zIndex: 1,
        }}
      >
        <Container
          maxW="container.lg"
          textAlign="center"
          color="white"
          position="relative"
          zIndex={2}
        >
          <VStack spacing={5}>
            <VStack spacing={2}>
              <Heading
                as="h2"
                size="xl"
                fontWeight="extrabold"
                color="white"
                mb={1}
              >
                Vuoi organizzare qualcosa in sede?
              </Heading>
              <Text
                fontSize="sm"
                maxW="560px"
                lineHeight="1.5"
                color="gray.300"
              >
                Offriamo la possibilità di organizzare{' '}
                <Text as="span" fontWeight="bold" color="gray.100">
                  feste di compleanno
                </Text>{' '}
                (con o senza animazione), workshop, tornei di giochi da tavolo,
                eventi privati e molto altro.{' '}
                <Text as="span" fontWeight="semibold" color="white">
                  Contattaci
                </Text>{' '}
                per disponibilità, prezzi e per raccontarci la tua idea.
              </Text>
            </VStack>
            <HStack spacing={4} flexWrap="wrap" justify="center">
              <Button
                bg="#ffcc00"
                color="black"
                size="lg"
                as={Link}
                to="/contattaci"
                rightIcon={<ExternalLinkIcon />}
                borderRadius="12px"
                fontWeight="600"
                _hover={{
                  bg: '#e6b800',
                  transform: 'translateY(-2px)',
                  boxShadow: '0 6px 20px rgba(255, 204, 0, 0.3)',
                }}
                transition="all 0.25s ease"
                px={8}
                py={4}
                fontSize="md"
              >
                Contattaci!
              </Button>
              <Button
                bg="transparent"
                color="white"
                size="lg"
                as={Link}
                to="/eventi"
                border="2px solid"
                borderColor="gray.600"
                borderRadius="12px"
                fontWeight="600"
                _hover={{
                  bg: 'gray.600',
                  transform: 'translateY(-2px)',
                  boxShadow: '0 6px 20px rgba(0, 0, 0, 0.3)',
                }}
                transition="all 0.25s ease"
                px={8}
                py={4}
                fontSize="md"
              >
                Scopri gli Eventi
              </Button>
            </HStack>
          </VStack>
        </Container>
      </Box>
    </Box>
  );
};

export default LaSede;
